import { Marquee } from './Marquee';
import { BannerSlider } from './BannerSlider';
import { CarouselBanner } from './CarouselBanner';
import { BannerGrid } from './BannerGrid';
import { CollectionGrid } from './CollectionGrid';
import { CollectionSlider } from './CollectionSlider';
import { Divider } from './Divider';
import { ProductGrid } from './ProductGrid';
import { ProductSlider } from './ProductSlider';
import { Cart } from './Cart';
import { Profile } from './Profile';
import { SingleBanner } from './SingleBanner';
import { SingleProduct } from './SingleProduct';
import { Search } from './Search';
import { RichText } from './RichText';
import { Announcement } from './Announcement';
import { ProductDetail } from './ProductDetail';
import { SignIn } from './SignIn';
import { SignUp } from './SignUp';
import { FrontPage } from './FrontPage';
import { ForgotPassword } from './ForgotPassword';
import { Button } from './Button';
import { CollectionList } from './CollectionList';
import { BottomBar } from './BottomBar';
import { AppBar } from './AppBar';
import { Notification } from './Notification';
import { ProductDetailDescription } from './ProductDetailDescription';
import { ProductDetailImage } from './ProductDetailImage';
import { ProductDetailVariants } from './ProductDetailVariants';
import { ProductDetailAddCart } from './ProductDetailAddCart';
import { Webview } from './Webview';
import { CategoryChips } from './CategoryChips';
import { MenuList } from './MenuList';
import { ProfileSettings } from './ProfileSettings';
import { ProfileAddress } from './ProfileAddress';
import { ProfileLanguages } from './ProfileLanguages';
import { ProfilePolicies } from './ProfilePolicies';
import { ProfileOrders } from './ProfileOrders';
import { ProductDetailComments } from './ProductDetailComments';
import { CargoBar } from './CargoBar';
import { ContinueOrder } from './ContinueOrder';
import { Popup } from './Popup';
import { ProductDetailAttributes } from './ProductDetailAttributes';
import { Timer } from './Timer';
import { BlogCard } from './BlogCard';

export const components = {
  Marquee,
  BannerGrid,
  BannerSlider,
  CarouselBanner,
  CollectionGrid,
  CollectionSlider,
  Divider,
  ProductGrid,
  ProductSlider,
  Cart,
  SingleBanner,
  Profile,
  SingleProduct,
  Search,
  RichText,
  Announcement,
  ProductDetail,
  SignIn,
  SignUp,
  FrontPage,
  ForgotPassword,
  Button,
  CollectionList,
  BottomBar,
  AppBar,
  Notification,
  ProductDetailImage,
  ProductDetailVariants,
  ProductDetailDescription,
  ProductDetailAddCart,
  Webview,
  MenuList,
  CategoryChips,
  ProfileSettings,
  ProfileAddress,
  ProfileLanguages,
  ProfilePolicies,
  ProfileOrders,
  ProductDetailComments,
  CargoBar,
  ContinueOrder,
  Popup,
  ProductDetailAttributes,
  Timer,
  BlogCard,
};
